import { Injectable } from '@angular/core';
import { ApiService } from "../api-service/api-service";

/*
  Generated class for the LotteryServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LotteryService {

  constructor(public apiService: ApiService) {

  }


  userLotteryRecord(params: any) {
    let seq = this.apiService.get('v1/userlottery', params).share();
    seq.subscribe((res: any) => {

    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 获取抽奖页面
  getLottery(params: any) {
    let seq = this.apiService.get('v1/lottery', params).share();
    seq.subscribe((res: any) => {

    }, err => {
      console.error(err);
    });

    return seq;
  }

  joinLottery(params: any) {
    let seq = this.apiService.post('v1/lottery', params).share();
    seq.subscribe((res: any) => {

    }, err => {
      console.error(err);
    });

    return seq;
  }



}



// WEBPACK FOOTER //
// ./src/providers/data-service/lottery-service.ts